import React, { useRef, useState } from "react"
import Slider from "react-slick"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { Box, Flex } from "@rebass/grid/emotion"
import Pager from "../pager/pager"
import {
  SliderAnimatedBar,
  SliderWrapper,
  SliderWrapperBasic,
  SliderWrapperSlide,
  SliderWrapperStat,
  SliderFooter,
} from "./slidebasic.styled"

const Sliderbasic = ({ data }) => {
  const {
    slides,
    timeToShow = 8,
    speed = 0.5,
    footnote = `Clinically tested results`,
  } = data
  const [autoplay, setAutoPlay] = useState(true)
  const sliderRef = useRef()
  const [curIndex, setCurIndex] = useState(0)
  const [now, setNow] = useState(0)
  const autoplaySpeed = timeToShow * 1000

  const settings = {
    autoplay,
    autoplaySpeed,
    dots: false,
    arrows: false,
    infinite: true,
    speed: speed * 1000,
    lazyLoad: "progressive",
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange(oldIndex, newIndex) {
      setCurIndex(newIndex)
      setTimeout(() => {
        setNow(+new Date())
      }, speed / 2)
    },
    onSwipe() {
      if (autoplay) {
        setAutoPlay(false)
      }
    },
  }

  const prevSlide = () => {
    sliderRef.current.slickPrev()
    setAutoPlay(false)
  }
  const nextSlide = () => {
    sliderRef.current.slickNext()
    setAutoPlay(false)
  }

  const buildSlide = (item, idx) => {
    const { stat, copy, copyCls = `` } = item

    return (
      <SliderWrapperBasic key={idx} className={`slider-basic-wrapper`}>
        <SliderWrapperSlide
          className={"slider-basic rounded-lg md:rounded-2xl"}
        >
          <SliderWrapperStat width={1}>
            <Box>
              <TextElementNova
                text={stat}
                className={`stat    text-nova-base-black Title-30-Super-Normal`}
              />
            </Box>
            <Box>
              <TextElementNova
                text={copy}
                className={
                  copyCls + ` copy Body-20-Dia-Normal text-nova-base-black`
                }
              />
            </Box>
          </SliderWrapperStat>
        </SliderWrapperSlide>
      </SliderWrapperBasic>
    )
  }

  return (
    <SliderWrapper
      style={{
        backgroundColor: slides[curIndex]?.backgroundColor || `#ECF1F5`,
      }}
    >
      <Slider {...settings} ref={sliderRef}>
        {slides.map(buildSlide)}
      </Slider>
      <SliderFooter width={1}>
        <Box>
          <SliderAnimatedBar
            key={now}
            delay={timeToShow}
            curIndex={curIndex}
            className={autoplay ? "animated" : "paused"}
          ></SliderAnimatedBar>
        </Box>
        <Box>
          <Pager
            nextSlide={nextSlide}
            prevSlide={prevSlide}
            text={footnote}
            textCls={`text-nova-base-black Caption-10-Dia-Uppercase text-center px-3`}
          />
        </Box>
      </SliderFooter>
    </SliderWrapper>
  )
}

export default Sliderbasic
